export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offres"])},
        "no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune offre trouvée"])},
        "column_category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Catégorie"])},
        "column_max_insurable_price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prix max assurable"])},
        "column_insurer_reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Référence assureur"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offers"])},
        "no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No offers found"])},
        "column_category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Category"])},
        "column_max_insurable_price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max insurable price"])},
        "column_insurer_reference": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Insurer reference"])}
      }
    }
  })
}
